import React, { useState, useEffect } from 'react';
import SplashScreen from './SplashScreen';
import WalletConnectionScreen from './WalletConnectionScreen';
import LandingPagePWA from './LandingPagePWA';

type FlowStage = 'splash' | 'wallet-connection' | 'landing';

const PWAEntryFlow: React.FC = () => {
  const [stage, setStage] = useState<FlowStage>('splash');

  useEffect(() => {
    // Show splash screen for 1 second, then move to wallet connection
    if (stage === 'splash') {
      const timer = setTimeout(() => {
        setStage('wallet-connection');
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [stage]);

  // Handle navigation from wallet connection screen
  const handleProceedToLanding = () => {
    setStage('landing');
  };

  // If we're on the landing stage, show the landing page
  if (stage === 'landing') {
    return <LandingPagePWA />;
  }

  // Show splash screen
  if (stage === 'splash') {
    return <SplashScreen />;
  }

  // Show wallet connection screen
  return <WalletConnectionScreen onProceed={handleProceedToLanding} />;
};

export default PWAEntryFlow;

